(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tabbed-collection-carousel')) {
    class TabbedCollectionCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(tab, true));

          tab.addEventListener('keydown', (event) => {
            const isRtl = getComputedStyle(this).direction === 'rtl';
            let nextIndex = null;

            if (event.key === 'ArrowRight') {
              nextIndex = isRtl ? index - 1 : index + 1;
            } else if (event.key === 'ArrowLeft') {
              nextIndex = isRtl ? index + 1 : index - 1;
            } else if (event.key === 'Home') {
              nextIndex = 0;
            } else if (event.key === 'End') {
              nextIndex = this.tabs.length - 1;
            }

            if (nextIndex === null) return;

            event.preventDefault();
            nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
            this.activateTab(this.tabs[nextIndex], true);
          });
        });
      }

      activateTab(activeTab, moveFocus = false) {
        const targetPanelId = activeTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === targetPanelId;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', String(!isActive));

          if (isActive) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }
        });

        activeTab.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });

        if (moveFocus) activeTab.focus();

        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    }

    customElements.define('tabbed-collection-carousel', TabbedCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
